import React, { Component } from "react";
import Input from "./../../common/Input";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import {
  getProjectDetails,
  saveProject,
} from "../../../services/projectService";
import * as Icon from "react-feather";
import CustomLoader from "../../common/Loader";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import ProjectForms from "./forms/ProjectForms";
import ProjectLists from "./lists/ProjectLists";
import ProjectUsers from "./access/ProjectUsers";
import { Link } from "react-router-dom";
import queryString from 'query-string';
import ProjectInstitutions from "./institutions/ProjectInstitutions";
import EmailSettings from './emailSettings/EmailSettings';
import { logActivity } from '../../../services/utilService';
import ProjectPayment from "./ProjectPayment";
import ProjectLinkingAppWhitelist from "./ProjectLinkingAppWhitelist";

class ProjectSettings extends Component {
 

  constructor(props) {
    super(props);

    const queryParameters = queryString.parse(props.location.search);
    const{Project_ID = 0} = queryParameters;
    this.state = {
      Project_ID,
      Project_Name: "",
      Project_Description: "",
      MPOG_Link_Form_ID: 0,
      loading: true,
      queryParameters,
      EnablePayment: false,
      EnablePaymentSetting: false,
      EnableLinkingAppWhitelist: false,
      EnableLinkingAppWhitelistSetting: false
    };

  }

  async componentDidMount() {

    if (this.state.Project_ID !== 0) {
      const { data } = await getProjectDetails(this.state.Project_ID);
      this.setState({ Project_Name: data[0].Project_Name });
      this.setState({ Project_Description: data[0].Project_Description });
      this.setState({ MPOG_Link_Form_ID: data[0].MPOG_Link_Form_ID });
      this.setState({ EnablePayment: data[0].EnablePayment ? data[0].EnablePayment : false});
      this.setState({ EnablePaymentSetting: data[0].EnablePayment ? data[0].EnablePayment : false })
      this.setState({ EnableLinkingAppWhitelist: data[0].EnableLinkingAppWhitelist ? data[0].EnableLinkingAppWhitelist : false })
      this.setState({ EnableLinkingAppWhitelistSetting: data[0].EnableLinkingAppWhitelist ? data[0].EnableLinkingAppWhitelist : false })
    }
    this.setState({ loading: false });
  }

  handleSubmit = async () => {
    //const { data } = await updateProjectDetail(this.state);
    const { data } = await saveProject(this.state);

    if (data.includes("Success")) {
      const Project_ID = parseInt(data.split(":").pop());
      this.setState({ Project_ID });
      this.setState({ EnablePaymentSetting: this.state.EnablePayment})
      this.setState({ EnableLinkingAppWhitelistSetting: this.state.EnableLinkingAppWhitelist})

      toaster('success', 'Project saved successfully');
      logActivity('/projectSettings', 'PROJECT_SAVE_SUCCESS');
      // setTimeout(() => {
      //   this.props.history.push("/projects");
      // }, 1000);
    } else {
      toaster('error', 'Error occured in saving project');
      logActivity('/projectSettings', 'PROJECT_SAVE_FAILED');
    }
  };

  handleChange = ({ currentTarget: input }) => {
    this.setState({ [input.name]: input.value });
  };

  // changeSelect = (name, selection) => {
  //   if (name === "MPOG_Link_FormProject_ID") {
  //     const project = { ...this.state.project };
  //     project["MPOG_Link_FormProject_ID"] = selection.value;
  //     this.setState({ project });
  //   } else {
  //     this.setState({ [name]: selection });
  //   }
  // };

  handleDefault = async (Form_ID) => {
    this.setState({ MPOG_Link_Form_ID: Form_ID });

    const { data } = await saveProject(this.state, Form_ID);
    if (data.includes("Error")) {
      toaster('error', 'Error setting default form');
      logActivity('/projectSettings', 'PROJECT_SETDEFAULT_FAILED');
    } else {
      toaster('success', 'Default form set.');
      logActivity('/projectSettings', 'PROJECT_SETDEFAULT_SUCCESS');
    }
  };

  handleEnablePaymentChange = () => {
    this.setState({EnablePayment: !this.state.EnablePayment})
  }

  handleEnableLinkingAppWhitelistChange = () => {
    this.setState({EnableLinkingAppWhitelist: !this.state.EnableLinkingAppWhitelist})
  }

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    const {
      Project_ID,
      Project_Name,
      Project_Description,
      MPOG_Link_Form_ID,
      EnablePayment,
      EnablePaymentSetting,
      EnableLinkingAppWhitelist,
      EnableLinkingAppWhitelistSetting
    } = this.state;
    return (
      <React.Fragment>
        <header className="page-header page-header-dark bg-gradient-primary-to-secondary mb-4">
          <div className="container">
            <div className="page-header-content pt-4">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto mt-4">
                  <h1 className="page-header-title">
                    <div className="page-header-icon">
                      <Icon.Tool />
                    </div>
                    {this.state.Project_ID === 0 && "New Project Settings"}
                    {this.state.Project_ID !== 0 && Project_Name + " Settings"}
                  </h1>
                  <div className="page-header-subtitle">
                    {Project_Description}
                  </div>
                </div>
              </div>
              <ol className="breadcrumb mb-0 mt-4">
                <li className="breadcrumb-item">
                  <Link
                    to={{
                      pathname: "/projects/",
                    }}
                  >
                    Projects
                  </Link>
                </li>
                <li className="breadcrumb-item active">{Project_Name}</li>
              </ol>
            </div>
          </div>
        </header>
        <div className="container">
          <Tabs
            defaultActiveKey={Project_ID === 0 ? "basic" : "forms"}
            variant="pills"
            className="rounded-0"
          >
            <Tab eventKey="basic" title="Basic">
              <div className="card mt-2 mb-4">
                <div className="card-body">
                  <Input
                    name="Project_Name"
                    value={Project_Name}
                    label="Project Name"
                    onChange={this.handleChange}
                  ></Input>

                  <Input
                    name="Project_Description"
                    value={Project_Description}
                    label="Project Description"
                    onChange={this.handleChange}
                  ></Input>

                  <div className="custom-control custom-switch mt-n2 mb-4">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      checked={EnablePayment}
                      value={EnablePayment}
                      onChange={this.handleEnablePaymentChange}
                      name='enablePaymentSwitch'
                      id='enablePaymentSwitch'
                    />
                    <label htmlFor='enablePaymentSwitch' className="custom-control-label">
                      Enable Payment
                    </label>
                  </div>

                  <div className="custom-control custom-switch mt-n2 mb-4">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      checked={EnableLinkingAppWhitelist}
                      value={EnableLinkingAppWhitelist}
                      onChange={this.handleEnableLinkingAppWhitelistChange}
                      name='enableWhitelistSwitch'
                      id='enableWhitelistSwitch'
                    />
                    <label htmlFor='enableWhitelistSwitch' className="custom-control-label">
                      Enable Linking App Whitelist
                    </label>
                  </div>

                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={this.handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </div>
            </Tab>
            <Tab eventKey="forms" title="Forms" disabled={Project_ID === 0}>
              <div className="card mt-2 mb-4">
                <div className="card-body">
                  <ProjectForms
                    Project_ID={Project_ID}
                    Default_Form={MPOG_Link_Form_ID}
                    handleDefault={this.handleDefault}
                  />
                </div>
              </div>
            </Tab>
            <Tab eventKey="lists" title="Lists" disabled={Project_ID === 0}>
              <div className="card mt-2 mb-4">
                <div className="card-body">
                  <ProjectLists Project_ID={Project_ID} />
                </div>
              </div>
            </Tab>
            <Tab
              eventKey="access"
              title="Access Control"
              disabled={Project_ID === 0}
            >
              <div className="card mt-2 mb-4">
                <div className="card-body">
                  <ProjectUsers Project_ID={Project_ID} />
                </div>
              </div>
            </Tab>
            <Tab
                eventKey="institutions"
                title="Institution Control"
                disabled={Project_ID === 0}
            >
              <div className="card mt-2 mb-4">
                <div className="card-body">
                  <ProjectInstitutions Project_ID={Project_ID} />
                </div>
              </div>
            </Tab>
            {EnablePaymentSetting && <Tab
                eventKey="payment"
                title="Payment"
                disabled={Project_ID === 0}
            >
              <div className="card mt-2 mb-4">
                <div className="card-body">
                  <ProjectPayment Project_ID={Project_ID} />
                </div>
              </div>
            </Tab>}
            {EnableLinkingAppWhitelistSetting && <Tab
                eventKey="whitelist"
                title="Linking App Whitelist"
                disabled={Project_ID === 0}
            >
              <div className="card mt-2 mb-4">
                <div className="card-body">
                  <ProjectLinkingAppWhitelist Project_ID={Project_ID} />
                </div>
              </div>
            </Tab>}
            {/* <Tab eventKey="emailSettings" title="Email Templates" disabled={Project_ID === 0}>
              <div className="card mt-2 mb-4">
                <div className="card-body">
                  <EmailSettings Project_ID={Project_ID} />
                </div>
              </div>
            </Tab> */}
          </Tabs>

          {/* <div className="card mb-4">
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <Input
                  name="name"
                  value={project.name}
                  label="Project Name"
                  onChange={this.handleChange}
                ></Input>

                <Input
                  name="description"
                  value={project.description}
                  label="Project Description"
                  onChange={this.handleChange}
                ></Input>

                <div className="form-group">
                  <label htmlFor="forms">Forms</label>
                  <Select
                    closeMenuOnSelect={false}
                    isMulti
                    value={forms}
                    options={this.form_options}
                    onChange={(selection) =>
                      this.changeSelect("forms", selection)
                    }
                    classNamePrefix="select"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="MPOG_Link_FormProject_ID">Default Form</label>
                  <Select
                    classNamePrefix="select"
                    value={forms.filter(
                      (form) => form.value === project.MPOG_Link_FormProject_ID
                    )}
                    isClearable={false}
                    name="MPOG_Link_FormProject_ID"
                    options={forms}
                    onChange={(selection) =>
                      this.changeSelect("MPOG_Link_FormProject_ID", selection)
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="users">Users</label>
                  <Select
                    closeMenuOnSelect={false}
                    isMulti
                    value={users}
                    options={this.user_options}
                    onChange={(selection) =>
                      this.changeSelect("users", selection)
                    }
                    classNamePrefix="select"
                  />
                </div>
                <button className="btn btn-outline-primary">Save</button>
              </form>
            </div>
          </div>
         */}
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default ProjectSettings;
